<script>
import Logo from "../components/logos/PrimaryLogo.vue";
export default {
  name: "logged-out-pages",
  components: { Logo },
  data() {
    return {
      hasCheckoutBackground: false,
    };
  },
  methods: {
    setCheckoutBackground(hasBackground) {
      this.hasCheckoutBackground = hasBackground;
    },
  },
};
</script>


<template>
  <div>
    <main class="loggedOutPage" style="width: 100%">
      <router-view
        @set-checkout-background="setCheckoutBackground"
      ></router-view>
    </main>
    <Logo
      :secondary="hasCheckoutBackground"
      set-width="130px"
      set-height="35px"
    />
  </div>
</template>

<style scoped>
@import "../styles/global.css";
@import "../styles/logged-out.css";

main.loggedOutPage {
  height: calc(100vh - 80px);
  width: 100%;
  margin: 0;
  padding: 0px 0.5rem;
  transition: var(--slow-med);
  overflow-y: scroll;
  overflow-x: hidden;
  place-items: center;
}
</style>